<template>
  <div class="align-self-center" v-auto-animate>

      <template v-if="hasSendEmail">

        

        <div class="login-app mt-4">
          <h2 class="text-start">Revisa tu correo electrónico</h2>
            <p class="mt-3">
              Si tu correo coincide con nuestra base de datos,
              te estará llegando un correo electrónico con el que podrás acceder
              a la plataforma.
            </p>
          </div>
      </template>

      <template v-else>

        <!-- <h2 class="modal__title text-white text-start">¡Te damos la bienvenida a la convención Comex 2023!</h2> -->

        <div class="login-app mt-4" style="max-width: 580px;">
          <h2>Inicia sesión</h2>
          <p for="" class="mt-3">Ingresa la cuenta de correo electrónico con que te registraste para obtener tu enlace de acceso al portal.</p>
          <label for="">*Correo electrónico</label>
          <input v-model="v$.user.email.$model" class="input-type-1" placeholder="E-mail"/>

          <label class="" v-if="v$?.user?.email?.$errors?.length > 0"> Ingresa un correo electrónico válido. </label>

          <div class="d-flex justify-content-end mt-4">
            <button type="button" class="btn-tertiary" @click.prevent="submit" :disabled="isLoading">
              <div v-if="isLoading" class="spinner-border spinner-border-sm"></div>
              Iniciar sesión
            </button>
          </div>
          <p v-if="hasRegister" class="mt-4">¿Aún no tienes una cuenta? <a class="underline text-center mt-4" style="color:#0190cb;" href="registro-lider">Regístrate ahora</a></p>
        </div>
      </template>
  </div>
</template>

<script>
import Modal from '@components/modal/Modal.vue';
import useVuelidate from "@vuelidate/core";
import { required, email } from '@vuelidate/validators'

export default {
  inject: ['$axios'],
  setup() {
    return { v$: useVuelidate() };
  },
  data: () => ({
    user: {
      email: null,
    },
    hasRegister: null,
    showModal: false,
    isLoading: false,
    hasSendEmail: false
  }),
  components:{ Modal },
  mounted() {
    this.checkForRegister();
  },
  methods: {
    checkForRegister() {
        if(!this.canOmitFlight) {
        this.$axios.get('/api/v1/check-for-register').then(response => {
          this.hasRegister = response.data;
        });
      }
    },
    show() {
      this.showModal = true;
    },
    submit(){
      this.v$.$validate().then(value => {
        if (value) this.sendMagicLink();
      });
    },
    sendMagicLink(){
      if (this.isLoading) return;
      this.isLoading = true;

      this.$axios.post(`/api/v1/login/send-magic-link`, {
        data: {
          email: this.user.email
        }
      }).then((r)=>{
        this.hasSendEmail = true;
      }).catch(e => {
        this.$swal.fire({
          icon: 'error',
          title: 'No se ha encontrado una cuenta con este correo.',
          showConfirmButton: true
        });
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  validations() {
    return {
      user: {
        email: { required, email }
      }
    };
  }
}
</script>
<style lang="scss" nonce>
.modal-footer,
.modal-header {
  border-top: 0 !important;
  border-bottom: 0 !important;
}
.error {
  color: red;
}
.input-type-1.input-type-1__border{
    color: white !important;
    border: 1px solid white !important
}
.input-type-1::placeholder { /* Microsoft Edge */
  color: white;
  font-size: 0.9em;
}
</style>